import { defineProfile } from "./define.js";

export const CAR_WORKSHOP_PROFILE = defineProfile("car_workshop", {
  labels: ["contacts", "bookings", "services", "staff", "orders"],
  home: ["bookings_today", "quotes_waiting", "unread_chats", "ai_handoffs"],
  kpis: ["bookings", "quotes_accepted", "revenue", "conversations", "ai_handoffs"],
  panel: ["appointments", "vehicle", "past_services", "quotes"],
  quickActions: ["book_appointment", "new_quote", "send_reminder"],
  contactFields: [
    { key: "plate_number", kind: "text", label: { ar: "رقم اللوحة", en: "Plate number" } },
    { key: "car_model", kind: "text", label: { ar: "موديل السيارة", en: "Car model" } },
  ],
  aiTools: ["search_kb", "lookup_availability", "book_slot", "escalate"],
  cloudStarterMenu: "appointments_menu",
  starterPack: "car-workshop",
});
